import { HideDialog, ShowDialog } from '@/store/dialog/actions';
import { useDispatch } from 'react-redux';
import { DialogIds } from './DialogIds.enum';

export const useDialog = () => {
    const dispatch = useDispatch();

    const showDialog = (id: DialogIds) => {
        dispatch(ShowDialog({ id }));
    };

    const hideDialog = () => {
        dispatch(HideDialog());
    };

    return {
        showDialog,
        hideDialog,
    };
};
